import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Content Schema
 * Represents a content that can be promoted by affiliates
 * Base schema is loose to allow loading legacy data.
 */
export const ContentSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    contentName: Yup.string().nullable(),
    contentUrl: Yup.string().nullable(),
    contentImg: Yup.mixed().nullable(),
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
    isHighlight: Yup.boolean().default(false),
  });

/**
 * Content Validation Schema
 * Strict rules applied only during form submission.
 */
export const ContentValidationSchema = ContentSchema.clone().shape({
  contentName: Yup.string()
    .required(ERROR_MESSAGES.CONTENT_NAME_REQUIRED)
    .min(5, ERROR_MESSAGES.MIN_CHARS(5)),
  contentUrl: Yup.string()
    .url(ERROR_MESSAGES.INVALID_URL)
    .required(ERROR_MESSAGES.CONTENT_URL_REQUIRED),
  isHighlight: Yup.boolean().required(ERROR_MESSAGES.REQUIRED),
});
